import { safeSignInDestination } from "~shared/signInDestination";
import React, { useEffect, useState } from 'react';

import { StyledContainer } from './styles';
import { useQuery } from '../../Utils';
import firebase from '../../Firebase.js';
import Auth from '../../Auth';
import Modal from 'react-modal';

import * as Sentry from "@sentry/react";


const customStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(55, 55, 55, 0.7)',
  },
  content: {
    top: '20%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    zIndex: '20000',
    width: '400px',
    transform: 'translate(-50%, 0)',
    borderRadius: "15px",
    border: "0px",
    padding: "0px",
    background: '#f5f2e4',
    boxShadow: 'var(--default-drop-shadow)'
  }
};

export default function EmailSignInVerify({ loadedUser }) {
  const [error, setError] = useState(false);
  const [resent, setResent] = useState(false);

  const query = useQuery();
  const email = query.get("email");
  const linkKey = query.get("linkKey");

  useEffect(() => {
    if (!email) {
      Sentry.captureMessage("EmailSignInVerify: Email is missing");
      return setError("email-missing");
    }
    if (!linkKey) {
      return setError("invalid");
    }
    if (!loadedUser) {
      // wait until user is loaded in case they are anonymous and we need to merge accounts
      return;
    }

    (async () => {
      try {
        const verification = await Auth.fetchWithIdToken("/api/login/sign-in-link/verify", {
          email,
          linkKey,
        });

        if (!verification.verified) {
          Sentry.captureMessage("EmailSignInVerify: Email is invalid or link is expired");
          return setError("invalid");
        }

        const userCred = await firebase.auth().signInWithCustomToken(verification.loginToken);
        window.location.href = safeSignInDestination(verification.conferenceNext || query.get("next"));
      } catch (e) {
        Sentry.captureException(e, {
          tags: {
            feature: "email-sign-in-verify",
          },
          extra: {
            hasEmail: !!email,
            hasLinkKey: !!linkKey,
          },
        });
        setError("generic");
      }
    })();
  }, [loadedUser]);

  return (
    <Modal
      isOpen={true}
      style={customStyles}
    >
      <StyledContainer>
        {!error && <h1>Verifying...</h1>}

        {error === "email-missing" && (
          <>
            <h1>This Sign in Link is Invalid</h1>
            <p>
              This can happen if the link was truncated or altered. Try going back to your email and clicking on the link again or <a href="/email-sign-in">try sending yourself a new link</a>
            </p>
          </>
        )}

        {error === "invalid" && (
          <>
            <h1>This Sign in Link has Expired</h1>
            <p>You may have already clicked on this link</p>
            {resent && <p>We've sent a fresh link to the email {email}. Check your inbox to sign in.</p>}
            {!resent && (
              <p>
                <a href="/app">Try sending yourself a new link</a>
              </p>
            )}
          </>
        )}

        {error === "generic" && (
          <>
            <h1>Uh oh, looks like something went wrong.</h1>
            <p>
              Email us at <a href="mailto:hi@sudowrite.com">hi@sudowrite.com</a> for help.
            </p>
          </>
        )}
      </StyledContainer>
    </Modal>
  );
}
